export default {
  namespaced: true,

  state: {
    // altijd home in development!!
    location: 'home',
    // in production info
    // location: 'info',
  },
  getters: {
    location(state) {
      return state.location;
    },
  },
  mutations: {
    UPDATE_LOCATION(state, location) {
      state.location = location;
    },
  },
  actions: {
    updateLocation({ commit }, location) {
      commit('UPDATE_LOCATION', location);
    },
  },
};
